import React from "react";
import { JHALA_GLOBAL_CSS, TopStrip, Header, Footer, Reveal, TagChip } from "components/jhala/Layout.js";

export default function TermsOfServicePage() {
  return (
    <div style={{ fontFamily: "'Inter', sans-serif", background: "#F6F4EE", color: "#0A0F1E" }}>
      <style>{JHALA_GLOBAL_CSS}</style>
      <TopStrip />
      <Header />

      <section style={{ background: "#0A0F1E", color: "#F6F4EE", padding: "56px 24px 48px" }}>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          <Reveal>
            <TagChip>$ jhalatech --legal terms</TagChip>
            <h1 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "clamp(26px, 3.6vw, 38px)", lineHeight: 1.15, margin: "16px 0 0" }}>
              Terms of Service
            </h1>
          </Reveal>
        </div>
      </section>

      <section style={{ padding: "60px 24px 90px", background: "#F6F4EE" }}>
        <div style={{ maxWidth: 800, margin: "0 auto", background: "#FFFFFF", border: "1px solid #DCD8CC", borderRadius: 8, padding: "40px 36px" }}>
          <Reveal>
            <div className="legal-content">
              <p><strong>Effective Date:</strong> Jan 01, 2025</p>
              <p>Welcome to JhalaTech! We're excited to have you here. Please read these Terms of Service ("Terms") carefully before using our website and services.</p>

              <h2>1. Acceptance of Terms</h2>
              <p>By accessing or using any part of our website or services, you agree to comply with and be bound by these Terms. If you do not agree, you may not access the site or use our services.</p>

              <h2>2. Overview of Services</h2>
              <p>JhalaTech provides IT solutions including:</p>
              <ul>
                <li>Shopify Development</li>
                <li>Web and App Development (Next.js, Node.js, etc.)</li>
                <li>UI/UX Design</li>
                <li>Maintenance and Support</li>
              </ul>
              <p>We tailor our services to businesses of all sizes, with remote-first engagement and on-site support as needed.</p>

              <h2>3. Eligibility</h2>
              <p>By using our services, you confirm that you have the legal capacity to enter into a binding agreement with JhalaTech. If you're using our services on behalf of a company or organization, you represent that you have the authority to bind that entity to these Terms.</p>

              <h2>4. Client Responsibilities</h2>
              <p>Clients agree to:</p>
              <ul>
                <li>Provide accurate project requirements</li>
                <li>Pay invoices in a timely manner</li>
                <li>Cooperate with developers and project managers</li>
              </ul>

              <h2>5. Payments</h2>
              <p>Payment terms are project-based or subscription-based as outlined in the agreement. Delays in payment may result in project suspension.</p>

              <h2>6. Intellectual Property</h2>
              <p>All intellectual property created by JhalaTech during the project remains the property of the client upon full payment. We may showcase the project in our portfolio.</p>

              <h2>7. Confidentiality</h2>
              <p>Both parties agree to keep confidential information private and not disclose it to third parties.</p>

              <h2>8. Limitation of Liability</h2>
              <p>JhalaTech shall not be liable for indirect or consequential damages resulting from service usage.</p>

              <h2>9. Refund Policy</h2>
              <p>We do not provide refunds once work has commenced. However, specific situations may be handled at our discretion. For more, visit our <a href="/refund-policy">Refund Policy</a>.</p>

              <h2>10. Termination</h2>
              <p>Either party may terminate the project upon written notice. Outstanding payments must be cleared upon termination.</p>

              <h2>11. Changes to Terms</h2>
              <p>We may update these Terms occasionally. Continued use of our services constitutes acceptance of any changes.</p>

              <h2>12. Governing Law</h2>
              <p>These Terms are governed by the laws of India, specifically the jurisdiction of Indore, Madhya Pradesh.</p>

              <h2>13. Contact Us</h2>
              <p>If you have any questions about these Terms, contact us at:</p>
              <ul>
                <li>📧 sales@jhalatech.in</li>
                <li>🌐 www.jhalatech.com</li>
                <li>📍 Indore, Madhya Pradesh, India</li>
              </ul>

              <p><strong>Thank you for choosing JhalaTech — Innovate. Integrate. Elevate.</strong></p>
            </div>
          </Reveal>
        </div>
      </section>

      <Footer />
    </div>
  );
}
